import React from 'React';
import axios from 'axios';

class ProductIcons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      icons: [],
    }
  }

  componentDidMount() {
    this.getIcons(this.props.product);
  }

  getIcons(product) {
    axios({
      url: '/api/2020-07/graphql.json',
      method: 'post',
      headers: {
        'X-Shopify-Storefront-Access-Token': 'a405dd74f8328bdcd981ff3210ccac7c',
        'Content-Type': 'application/json'
      },
      data: {
        query: `
        query {
          productByHandle(handle: "${product}") {
            metafields(first: 5, namespace: "nourishment_icons") {
                edges {
                node {
                  key
                  value
                }
              }
            }
          }
        }
        `
      }
    }).then((response) => {
      const iconString = response.data.data.productByHandle.metafields.edges[0].node.value;
      const iconsArr = iconString.split('|');
      this.setState({ icons: iconsArr });
    }).catch(function (error) {
      console.log(error);
      console.log('response failed');
    })
  }

  render() {
    const images = this.state.icons.map((item, index) => {
      const icon = item.toLowerCase().replace(/,|&/g, '').replace(/ /g, '-');

      switch (icon) {
        case 'anti-aging':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/anti-aging.svg?v=1595329629" /></li>
          break;
        case 'anti-inflammitory':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/anti-inflammatory.svg?v=1595329629" /></li>
          break;
        case 'bone-health':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/bone-health.svg?v=1595329629" /></li>
          break;
        case 'brain--mind':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/brain--mind.svg?v=1595329629" /></li>
          break;
        case 'digestive':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/digestive.svg?v=1595329629" /></li>
          break;
        case 'endurance':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/endurance.svg?v=1595329629" /></li>
          break;
        case 'energy':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/energy.svg?v=1595329629" /></li>
          break;
        case 'eye-health':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/eye-health.svg?v=1595329629" /></li>
          break;
        case 'hair-skin--nails':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/hair-skin--nails.svg?v=1595329629" /></li>
          break;
        case 'cardiovascular-health':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/heart-health.svg?v=1595329629" /></li>
          break;
        case 'immunity':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/immunity.svg?v=1595329629" /></li>
          break;
        case 'liver-health':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/liver-health.svg?v=1595329629" /></li>
          break;
        case 'prenatal':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/prenatal.svg?v=1595329629" /></li>
          break;
        case 'sleep-quality':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Sleep.svg?v=1629362448" /></li>
          break;
        case 'weight-management':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/weight-loss.svg?v=1616168911" /></li>
        case 'menopause-support':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Menopause-2.svg?v=1638873125" /></li>
        case 'insulin--hormone-balance':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Insulin.svg?v=1638873203" /></li>
        case 'metabolic-health':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Metabolic.svg?v=1638873367" /></li>
        case 'relieves-symptoms-of-pcos':
          return <li key={index}><img src="https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Menopause_1.svg?v=1638873376" /></li>
        default:
          return <li key={index}><b>{icon}</b></li>
          break;
      }

    });

    return (
      <ul className="results-nourishment__icons">
        {images}
      </ul>
    );
  }
}

export default ProductIcons;